<mat-toolbar class="bg-danger">
    <span>Pytanie <i class="fa-solid fa-question"></i></span>
    <span class="toolbar-spacer"></span>
    <button class="text-white" mat-icon-button matTooltip="Zamknij" matTooltipPosition="below" [mat-dialog-close]="true"
            aria-hidden="false">
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>
<mat-dialog-content>
    <div class="container text-center">
        <h4>Czy jesteś pewien by zakończyć depozyt?</h4>
        <div class="py-2">
            <mat-checkbox color="primary" [(ngModel)]="checked">Tak, jestem.</mat-checkbox>
        </div>
    </div>
</mat-dialog-content>
<div class="d-flex justify-content-end pb-4">
    <button class="full-width mx-2" mat-raised-button [mat-dialog-close]="true"
            matTooltip="Wyjdź" matTooltipPosition="below" aria-hidden="false">
        <i class="fa-solid fa-xmark"></i> NIE
    </button>
    <button class="full-width mx-2" mat-raised-button color="warn" (click)="completed()"
            matTooltip="Usuń" matTooltipPosition="below"
            [disabled]="isSaved || !checked">TAK <i class="fa-solid fa-check"></i></button>
</div>
